import React, { Fragment, useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Loader from '../component/common/loader';
import Header from '../component/Header/Header';
import Footer from '../component/Footer/Footer';
import './scss/DefaultLayout.scss'
import { courseAction } from "../store/courseSlice";
import { useDispatch } from "react-redux";

const DefaultLayout = (props) => {
    const [language, setLanguage] = useState('');
    const dispatch = useDispatch()
    useEffect(() => {
        if (!window.location.href.toString().includes("/courses-list-new"))
            dispatch(courseAction.setSearchParam(""));
    }, [window.location.href]);

    useEffect(() => {
        setLanguage(localStorage.getItem("i18nextLng"));
    }, [localStorage.getItem("i18nextLng")])
    return (
        <Fragment>
            <div className={`main-wrapper`}>
                <Header />
                <div className={`defaultayout-body ${language}`}>
                    <Outlet />
                </div>
                <Footer />
                <Loader />
            </div>
        </Fragment>
    )
}
export default DefaultLayout;